"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var linearInterpolation = function (range1, range2, n) {
    if (range1.length !== range2.length)
        return null;
    var exactMatchedIdx = range1.findIndex(function (it) { return it === n; });
    if (exactMatchedIdx >= 0)
        return range2[exactMatchedIdx];
    if (range1.slice(-1)[0] === -1 && n > range1.slice(-2)[0])
        return range2.slice(-1)[0];
    var match = range1.map(function (it, i) {
        if (i < range1.length - 1 && n > it && n < range1[i + 1])
            return ({ fromIdx: i, toIdx: i + 1, fromValue: it, toValue: range1[i + 1] });
        return null;
    }).filter(function (it) { return it; })[0];
    if (!match)
        return 0;
    return Math.round(((range2[match.toIdx] - range2[match.fromIdx]) * ((n - match.fromValue) / (match.toValue - match.fromValue)) + range2[match.fromIdx]) * 100) / 100;
};
var DoubleSlider = function (props) {
    var toMultiplied = function (real) { return linearInterpolation(props.real, props.multiplied, real); };
    var toReal = function (multiplied) { return linearInterpolation(props.multiplied, props.real, multiplied); };
    var min = props.real[0];
    var max = props.real.slice(-1)[0];
    var fromValue = toReal(props.from);
    var toValue = toReal(props.to);
    var onMinChanged = function (e) {
        var multiplied = toMultiplied(Number(e.target.value));
        if (multiplied === -1)
            return;
        if (props.to === -1 || multiplied < props.to)
            props.onMinChanged(multiplied);
    };
    var onMaxChanged = function (e) {
        var multiplied = toMultiplied(Number(e.target.value));
        if (multiplied === -1 || multiplied > props.from)
            props.onMaxChanged(multiplied);
    };
    var fromPercent = Math.ceil(fromValue / max * 100);
    var toPercent = Math.floor(toValue / max * 100);
    return (React.createElement("div", { className: "c-doubleslider" },
        React.createElement("div", { className: "c-doubleslider__track" },
            React.createElement("div", { style: { left: fromPercent + "%", right: 100 - toPercent + "%" }, className: "c-doubleslider__range" }),
            React.createElement("input", { onChange: onMinChanged, type: "range", step: 1, min: min, max: max, value: fromValue, className: "c-doubleslider__nub c-doubleslider__nub--min" }),
            React.createElement("input", { onChange: onMaxChanged, type: "range", step: 1, min: min, max: max, value: toValue, className: "c-doubleslider__nub c-doubleslider__nub--max" })),
        React.createElement("div", { className: "c-doubleslider__scale" },
            React.createElement("div", { className: "c-doubleslider__mark c-doubleslider__mark--empty" }, props.fromName),
            React.createElement("div", { className: "c-doubleslider__mark c-doubleslider__mark--empty" },
                " ",
                props.toName))));
};
exports.default = DoubleSlider;
